import React from 'react';

const Colors = ({ list, type, func }) => {
	const listHandle = () => {
		const colors = ['#3380C1', '#6F386B', '#79B542', '#CF571E', '#00B8BF'];

		if (list) {
			return list.map((value, key) => {
				let color = colors[key % colors.length];

				if (type == 'header-keywords') {
					return (
						<li onClick={func && func} key={key} className="eachRelatedQuery" style={{ color }}>
							#{value.text}
						</li>
					);
				} else {
					return (
						<div className="keyword-wrap">
							<button className="keywordButton">
								<span style={{ color }}>#{value}</span>
							</button>
						</div>
					);
				}
			});
		}
	};

	return listHandle();
};

export default Colors;



// WEBPACK FOOTER //
// ./src/components/searchResult/Colors.jsx